import { Modal, Button } from "react-bootstrap";
import "./style.scss";

export default function ConfirmModal(props) {
    return (
        <div id="confirm-modal">
            <Modal
                {...props}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="confirm-modal"
            >
                <Modal.Body>
                    <h4>{props.title}</h4>
                    <p>{props.description}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="confirm-btn"
                        onClick={(e) => {
                            e.preventDefault();
                            props.onConfirm(e);
                        }}
                    >
                        {props.btnTitle}
                    </Button>
                    {!props.hideCancelBtn && (
                        <Button
                            className="cancel-btn"
                            onClick={(e) => {
                                e.preventDefault();
                                props.onHide(e);
                            }}
                        >
                            انصراف
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
}
